// src/modules/Courier/pages/CourierModal/pages/ContactsPage.jsx
import React, { useEffect, useState } from 'react';
import { useModalPage } from '../CourierModal.jsx';
import { useRouteStore } from '../../Route/useRouteStore';
import api from '../../../../services/api.js';
import styles from '../styles/ContactsPage.module.css';

export default function ContactsPage() {
  const { close } = useModalPage();
  const receipt = useRouteStore(s => s.selectedReceipt);
  const receiptId = receipt?.id;

  const [contacts, setContacts] = useState(null);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);

  useEffect(() => {
    if (!receiptId) return;
    setLoading(true);
    api.get(`/receipts/${receiptId}/contacts`)
      .then(resp => setContacts(resp.data ?? resp))
      .catch(() => setError('Не удалось загрузить контакты'))
      .finally(() => setLoading(false));
  }, [receiptId]);

  // Ловим любые номера: +7, 8, с пробелами/тире/скобками
  const PHONE_RE = /(\+?8?\d[\d\-\s()]{4,}\d)/g;

  function maskPhone(raw) {
    const digits = raw.replace(/\D/g, '');
    if (digits.length < 4) return raw;
    const start = digits.slice(0,2);
    const end   = digits.slice(-2);
    const mid   = '*'.repeat(digits.length - 4);
    return (start + mid + end).replace(/(.{2})(?=.)/g, '$1-');
  }

  function onCall(raw) {
    const clean = raw.replace(/\D/g, '');
    window.location.href = `tel:${clean}`;
  }

  // превращает любой текст в React-масив строк+кнопок
  function renderWithPhones(text) {
    if (!text) return null;
    const parts = [];
    let last = 0;
    text.replace(PHONE_RE, (match, p1, offset) => {
      if (offset > last) {
        parts.push(text.slice(last, offset));
      }
      parts.push(
        <button
          key={offset}
          className={styles.phoneButton}
          onClick={() => onCall(p1)}
        >{maskPhone(p1)}</button>
      );
      last = offset + p1.length;
      return match;
    });
    if (last < text.length) {
      parts.push(text.slice(last));
    }
    return parts;
  }

  return (
    <div className={styles.modalContainer}>
      <div className={styles.header}>
        <h2 className={styles.title}>Контакты и комментарии</h2>
        <button className={styles.closeButton} onClick={close}>✕</button>
      </div>

      <div className={styles.body}>
        {loading && <p className={styles.loading}>Загрузка...</p>}
        {error   && <p className={styles.error}>{error}</p>}
        {contacts && (
          <>
            {contacts.delivery_comment && (
              <div className={styles.commentBlock}>
                <strong>Комментарий к доставке:</strong>
                <p className={styles.commentText}>
                  {renderWithPhones(contacts.delivery_comment)}
                </p>
              </div>
            )}
            {contacts.contract_comment && (
              <div className={styles.commentBlock}>
                <strong>Комментарий к договору:</strong>
                <p className={styles.commentText}>
                  {renderWithPhones(contacts.contract_comment)}
                </p>
              </div>
            )}
            {contacts.phone_number && (
              <div className={styles.commentBlock}>
                <strong>Телефон(ы):</strong>
                <p className={styles.commentText}>
                  {renderWithPhones(contacts.phone_number)}
                </p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
